import { Box, Grid, Paper, Skeleton, Stack } from '@mui/material';
import { BASE_COLORS } from 'lib/functions/const/colors';
import React from 'react';

const RiskCalculatorSkeleton: React.FC = () => {
  return (
    <Paper
      sx={{
        p: 1.5,
        boxShadow: 'none',
        border: `1px solid ${BASE_COLORS.softGray}`,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <Box
          sx={{
            backgroundColor: BASE_COLORS.blue,
            borderRadius: '50%',
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        ></Box>
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width={140} height={20} />
          <Skeleton variant="rounded" width={40} height={18} sx={{ mt: 0.5 }} />
        </Box>
        <Box sx={{ textAlign: 'right' }}>
          <Skeleton variant="text" width={120} height={32} />
          <Skeleton variant="text" width={40} height={18} sx={{ mt: 0.5 }} />
        </Box>
      </Stack>

      <Box
        sx={{
          backgroundColor: `${BASE_COLORS.softGray}1A`,
          p: 1.5,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'grey.200',
        }}
      >
        <Grid container spacing={1}>
          {[...Array(6)].map((_, index) => (
            <Grid item xs={12} key={index}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1,
                }}
              >
                <Skeleton variant="text" width={150} height={14} />
                <Skeleton variant="text" width={110} height={16} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default RiskCalculatorSkeleton;
